import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { from, Observable } from 'rxjs';
import { mergeMap, skipWhile, skip, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { LOG_REPORTER_KEYS, LogReporterService } from '../service/log-reporter.service';

@Injectable(
  /**
   * NOT INJECTABLE VIA DI: This interceptor is provided in the app module, not in the root injector.
   * This is to ensure that it is only instantiated once and can access the AngularFireAuth
   */
)
export class TokenInterceptor implements HttpInterceptor {

  private timeout: NodeJS.Timeout;
  readonly URLs_TO_INTERCEPT = [
    environment.mkgoURL,
    environment.migrate.URL
  ];

  private _logReporter = inject(LogReporterService);

  constructor(
    private auth: AngularFireAuth,
    private dialog: MatDialog
  ) {
    const logger = this._logReporter.textLogger('TokenInterceptor', LOG_REPORTER_KEYS.INVOICE);
    this.auth.idToken.pipe(
      skipWhile(token => !token),
      skip(1)
    ).subscribe(() => logger('Token renovado'));
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(
      () => {
        this.dialog.closeAll();
        this.auth.signOut();
      },
      6 * 60 * 60 * 1000
    );
    if (this.URLs_TO_INTERCEPT.some(url => request.url.startsWith(url))) {
      return from(this.auth.currentUser.then(user => user?.getIdToken()))
        .pipe(
          mergeMap((token: string | null) => {
            if (token) {
              request = request.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
              });
            }
            return next.handle(request);
          })
        );
    }
    return next.handle(request);
  }

}
